/**

Coded by www.techhighway.ca

*/

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";

const { text, info } = colors;

const formLabel = {
  styleOverrides: {
    root: {
      color: text.main,
      "&.Mui-focused": {
        color: `${info.main} !important`,
      },
    },
  },
};

export default formLabel;
